module.exports = __webpack_public_path__ + "static/img/ru.676c192.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/ru.png
// module id = gKki
// module chunks = 18